import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { DoubleArrow, DownArrow, UpArrow } from 'ui/icons';
import { button, colors, spacing } from 'ui/theme';
import noop from 'utils/noop';
import { Cell } from './Table.styled';

export const HEADER_CELL_TEXT = {
  headerCellId: 'header-cell',
  sortableCellId: 'sortable-header-cell',
  sortedAscendingId: 'sorted-ascending',
  sortedDescendingId: 'sorted-descending',
  unsortedId: 'unsorted',
};

const { headerCellId, sortableCellId, sortedAscendingId, sortedDescendingId, unsortedId } =
  HEADER_CELL_TEXT;

const SortableCell = styled.button`
  ${button}
  display: flex;
  align-items: center;
  gap: ${spacing.quarter};
  padding: ${spacing.half} 0;
  cursor: 'pointer';
  background: none;
  border: none;

  &[data-active='true'] {
    color: ${colors.textInteractive};
  }
`;

export type Props = {
  children: ReactNode;
  /** value for column to align with sortBy, if not used then no sort arrows will be shown */
  name?: string;
  onClick?: (name: string) => void;
  sortBy?: string;
  sortDirection?: SORT_DIRECTIONS;
};

export const HeaderCell = ({ children, name, onClick = noop, sortBy, sortDirection }: Props) => {
  /** Sort by this column if sortBy equals name provided */
  const isActive = sortBy === name;
  const isAscending = sortDirection === SORT_DIRECTIONS.ASCENDING;
  const isSortable = !!name;

  return isSortable ? (
    <SortableCell
      data-active={isActive.toString()}
      data-test={`${sortableCellId}-${name}`}
      onClick={() => onClick(name)}
    >
      <span>{children}</span>
      {!isActive && <DoubleArrow data-test={unsortedId} isColorInherited />}
      {isActive && isAscending && <UpArrow data-test={sortedAscendingId} isColorInherited />}
      {isActive && !isAscending && <DownArrow data-test={sortedDescendingId} isColorInherited />}
    </SortableCell>
  ) : (
    <Cell data-test={headerCellId}>{children}</Cell>
  );
};
